<template lang="pug">
.caseDialogue(v-disabled="seeState")
  .Dialogue-box
    Form()
      FormItem(label="资料库" :label-width="80")
        iDelModel.ide(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')" :isDep="isEdit" @handleDel='handleDelInfo')
      FormItem(v-for="(app,index) in question.infoData" :key="app.key" :label="`#资料${index + 1}`" :label-width="80")
        Row(:gutter="16")
          Col(span="16")
            Input(type='text',placeholder='请输入资料' v-model="app.title" :maxlength="10")
          Col(span="4")
            Button(v-if="index != 0" type="error" shape="circle" icon="md-close" size="small" @click="handleDel(index)")
        div(style="padding:0 8px;margin-top:20px;")
          quillEditor(ref="myQuillEditor2" :options="editorOption" v-model="app.descr")
        div(style="padding:0 8px;margin-top:20px;")
          Upload(ref="upload",:before-upload="(file)=>handleUpload(file,index)",multiple,:show-upload-list="true",:on-remove="(file,fileList)=>handleRemoveFile(fileList,index)"
                  :max-size="10240"
                  :default-file-list="app.urlList || []"
                  action=" " style="display:block;")
                  Button.button + 上传文件
                  p.uploadDesc 文件格式支持pdf、doc、docx、xls、xlsx、ppt、pptx，文件大小限制10M。
      FormItem(:label-width="80" v-if="!isDisabled")
        Button(type="primary" ghost @click="handleAdd") + 添加
      //-     Button.button(@click='addMeta2',
      //- style='color:#3A76D2;border: 1px solid #3A76D2;text-align:left;margin-left: 0px;') + 添加分析师讲话
</template>

<script>
import iDelModel from "@/components/common/iDelModel";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    iDelModel,
    quillEditor
  },
  props: ["data"],
  inject: ["seeState"],

  data() {
    return {
      editorOption: {
        placeholder: "请输入资料库内容",
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "image",
              "link",
              { indent: "-1" },
              { indent: "+1" },
              { align: "" },
              { align: "center" },
              { align: "right" },
              { color: [] },
              { background: [] },
              {
                font: [
                  "SimSun",
                  "SimHei",
                  "Microsoft-YaHei",
                  "KaiTi",
                  "FangSong",
                  "Arial",
                  "sans-serif"
                ]
              },
              { size: ["small", false, "large", "huge"] }
            ]
          ]
        }
      },
      question: {
        infoData: [
          {
            title: "",
            urlList: [],
            descr: "",
            key: "a",
            id: "",
            bizCode: "ZLK"
          }
        ]
      }
    };
  },
  computed: {
    isDisabled() {
      return sessionStorage.getItem("isDisabled") === "true";
    },
    taskInfo() {
      return JSON.parse(sessionStorage.getItem("taskInfo"));
    },
    isEdit() {
      return this.question.infoData.some((v) => v.id !== "");
    }
  },
  methods: {
    handleRemoveFile(fileList, index) {
      this.question.infoData[index].urlList = fileList;
    },
    async handleUpload(file, index) {
      const fileType = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx"];
      if (!fileType.includes(file.name.slice(file.name.lastIndexOf(".")))) {
        this.$Message.warning("文件类型不正确！");
        return false;
      }
      if (file.size > 10485760) {
        this.$Message.warning("文件大小不能超过10M！");
        return false;
      }
      try {
        const { data } = await this.$http.MaterialsUploadFile(file);
        console.log(
          {
            name: file.name,
            url: data.data
          },
          "file"
        );
        this.$nextTick(() => {
          this.question.infoData[index].urlList.push({
            name: file.name,
            url: data.data
          });
        });
      } catch (error) {
        return false;
      }
      console.log(this.question.infoData[index].urlList, "urllist");
      return false;
    },
    async handleDelInfo() {
      try {
        console.log(this.taskInfo.id, "ZLK");
        await this.$http.batchDeleteInfo(this.taskInfo.id, "ZLK");
        this.$Message.success("删除成功！");
        this.$emit("delModel");
      } catch (error) {
        console.log(error);
      }
    },
    handleAdd() {
      if (this.question.infoData.length === 50) {
        this.$Message.error("不能超过50条！");
        return;
      }
      this.question.infoData.push({
        title: "",
        descr: "",
        key: Math.floor(Math.random() * 1000000).toString(),
        bizCode: "ZLK",
        url: []
      });
    },
    handleDel(index) {
      this.question.infoData = this.question.infoData.filter((val, i) => i !== index);
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        if (Array.isArray(this.data)) {
          this.question.infoData = this.data;
        } else {
          this.question = this.data;
        }
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="stylus"></style>

<style lang="less" scoped>
.uploadDesc {
  font-size: 12px;
  font-family: MicrosoftYaHeiUI;
  color: rgba(128, 128, 128, 0.5);
}
</style>
